import axios from 'axios'
import { GET_CALENDAR_URL } from '../constants/urls'
import { parseSchedulingCalendars } from '../utils/scheduling'
import { formatDate } from '../utils/dates'
import { DATE_FORMATS } from '../constants/scheduling'

export async function getCalendar({ fxbuyflowSessionId }) {
  const { data: res } = await axios.get(
    `${GET_CALENDAR_URL}/${fxbuyflowSessionId}`
  )
  return res?.data?.nextApiToCall?.length === 2
    ? res
    : parseSchedulingCalendars
      ({ status: res.status, messages: res.messages, ...res.data })
}

export async function refreshQuotaWithDate({
  fxbuyflowSessionId,
  selectedDate,
  calendarType
}) {
  const formattedDate = formatDate(selectedDate, DATE_FORMATS.ISO_DATE)
  const { data: res } = await axios.get(
    `${GET_CALENDAR_URL}/${fxbuyflowSessionId}?userSelectedDate=${formattedDate}&calendarType=${calendarType}`
  )
  return parseSchedulingCalendars({
    ...res.data,
    messages: res.messages
  })
}
